import http, { handleApiResponse, handleApiResponseWithSuccess } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";

export default class CardPaymentsApi {
  static getExcel(paymentDate: string): Promise<string> {
    return http.post<ApiResponse<string>>(`bankout/excel-card-payments`, { PaymentDate: paymentDate }).then(handleApiResponse);
  }

  static changeVirtualPayment(viro: number, newShipDate: string | null, newAmount: number | null): Promise<unknown> {
    return http.post<ApiResponse<unknown>>(`bankout/change-card-payment`, {
      Viro: viro,
      NewShipDate: newShipDate,
      NewAmount: newAmount,
    }).then((r) => handleApiResponseWithSuccess(r, "Sikeres módosítás"));
  }

  static printViro(viro: number): Promise<string[]> {
    return http
      .post<ApiResponse<string[]>>(`open-invoices/print-viros`, { viros: [viro] })
      .then(handleApiResponse);
  }
}
